import { type FC } from "react";
import { Link } from "@tanstack/react-router";
import "./Banner.css";

type BannerProps = {
  content: string;
  to?: string;
  newTab?: boolean; 
};

export const Banner: FC<BannerProps> = ({ content, to, newTab }) => {
  return (
    <div className="banner">
      {to ? (
        <Link to={to} target={newTab ? "_blank" : "same"} className="banner-link">
          <span className="banner-content">{content}</span>
        </Link>
      ) : (
        <span className="banner-content">{content}</span>
      )}
    </div>
  );
};
